/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Actor": [
      "ApiKeyWithOrganization",
      "FinleyAutomated",
      "UnknownActor",
      "UserActor"
    ],
    "CategorySpecificProperties": [
      "FundingRequestTaskSpecificProperties",
      "InvoiceTaskSpecificProperties",
      "FundingDisbursementTaskSpecificProperties",
      "PaymentInKindItemTaskSpecificProperties",
      "LenderSharesTaskSpecificProperties"
    ],
    "DeliverableArtifactConfig": [
      "CashBalancesFeedConfig",
      "SupplementalTapeConfig",
      "LoanTapeConfig",
      "RepaymentTapeConfig",
      "PortfolioCovenantConfig",
      "FinancialCovenantConfig",
      "OrgProvidedInputConfig",
      "MonthlyServicerReportConfig",
      "MonthlyStatementConfig",
      "FinancialStatementConfig"
    ],
    "DeliverableArtifactInstanceDownload": [
      "ArtifactInstanceDownloadUrl",
      "ArtifactInstanceDownloadObject"
    ],
    "FundingMechanicsConstraint": [
      "FundingMechanicsNonConditionConstraint",
      "FundingMechanicsConditionConstraint"
    ],
    "Payload": [
      "FundingRequestPayload",
      "FundingRequestComponentPayload",
      "DeliverablesPayload",
      "IngestionPayload",
      "InsertedDeliverablePayload",
      "UpdatedDeliverableStatusPayload",
      "SubmittedDeliverableSubmissionPayload",
      "VerificationPayload"
    ],
    "PostgresQueryInputValues": [
      "PrincipalBalanceDailyAverageInputValues",
      "TAccountsSumInputValues",
      "OrgProvidedInputInputValues"
    ],
    "ReportTemplate": [
      "BaseReportTemplate"
    ],
    "SuccessOrErrorPortfolioCovenant": [
      "SuccessPortfolioCovenant",
      "ErrorPortfolioCovenant"
    ],
    "ValidateAndCreateWorkflowTemplateResponse": [
      "ErrorCreateWorkflowTemplateResponse",
      "SuccessCreateWorkflowTemplateResponse"
    ],
    "WorkflowActionStaticParamTemplateType": [
      "StringStaticParamTemplate",
      "NumberStaticParamTemplate",
      "StringArrayStaticParamTemplate"
    ],
    "WorkflowRuntimeVariableTemplate": [
      "StringRuntimeVariableTemplate",
      "StringArrayRuntimeVariableTemplate",
      "NumberRuntimeVariableTemplate"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Actor": [
      "ApiKeyWithOrganization",
      "FinleyAutomated",
      "UnknownActor",
      "UserActor"
    ],
    "CategorySpecificProperties": [
      "FundingRequestTaskSpecificProperties",
      "InvoiceTaskSpecificProperties",
      "FundingDisbursementTaskSpecificProperties",
      "PaymentInKindItemTaskSpecificProperties",
      "LenderSharesTaskSpecificProperties"
    ],
    "DeliverableArtifactConfig": [
      "CashBalancesFeedConfig",
      "SupplementalTapeConfig",
      "LoanTapeConfig",
      "RepaymentTapeConfig",
      "PortfolioCovenantConfig",
      "FinancialCovenantConfig",
      "OrgProvidedInputConfig",
      "MonthlyServicerReportConfig",
      "MonthlyStatementConfig",
      "FinancialStatementConfig"
    ],
    "DeliverableArtifactInstanceDownload": [
      "ArtifactInstanceDownloadUrl",
      "ArtifactInstanceDownloadObject"
    ],
    "FundingMechanicsConstraint": [
      "FundingMechanicsNonConditionConstraint",
      "FundingMechanicsConditionConstraint"
    ],
    "Payload": [
      "FundingRequestPayload",
      "FundingRequestComponentPayload",
      "DeliverablesPayload",
      "IngestionPayload",
      "InsertedDeliverablePayload",
      "UpdatedDeliverableStatusPayload",
      "SubmittedDeliverableSubmissionPayload",
      "VerificationPayload"
    ],
    "PostgresQueryInputValues": [
      "PrincipalBalanceDailyAverageInputValues",
      "TAccountsSumInputValues",
      "OrgProvidedInputInputValues"
    ],
    "ReportTemplate": [
      "BaseReportTemplate"
    ],
    "SuccessOrErrorPortfolioCovenant": [
      "SuccessPortfolioCovenant",
      "ErrorPortfolioCovenant"
    ],
    "ValidateAndCreateWorkflowTemplateResponse": [
      "ErrorCreateWorkflowTemplateResponse",
      "SuccessCreateWorkflowTemplateResponse"
    ],
    "WorkflowActionStaticParamTemplateType": [
      "StringStaticParamTemplate",
      "NumberStaticParamTemplate",
      "StringArrayStaticParamTemplate"
    ],
    "WorkflowRuntimeVariableTemplate": [
      "StringRuntimeVariableTemplate",
      "StringArrayRuntimeVariableTemplate",
      "NumberRuntimeVariableTemplate"
    ]
  }
};
      export default result;
    